export default __webpack_public_path__ + "static/breadcrumbs-parts-7d789881fd74b2cd7ba4ee56a5a5be46d304d7832ba91cb745d67947d1685cc7.png";